import { DealerUsersProps } from "store/modules/DealerUsers/types.store";
import {
  CoverageAreaDriverEntry,
  CoverageAreaProps,
} from "store/modules/Logistics/types.store";
import type { DriverOption } from "./coverageAreaDrivers";

export function clearSingleDriverStatePatch(): Pick<
  CoverageAreaProps,
  "drivers" | "hasDriver"
> {
  return {
    drivers: [],
    hasDriver: false,
  };
}

export function buildMapAreaDriversStatePatch(
  optionsInOrder: DriverOption[],
  dealerId: string,
  users: DealerUsersProps[],
): Pick<CoverageAreaProps, "drivers" | "hasDriver"> {
  const drivers: CoverageAreaDriverEntry[] = optionsInOrder.map(
    (opt, index) => {
      const user = users.find((u) => u.id === opt.id);
      return {
        priority: index,
        details: {
          id: opt.id,
          dealerId,
          name: user?.name ?? undefined,
          surname: user?.surname ?? undefined,
          enabled: true,
        },
      };
    },
  );

  if (drivers.length === 0) {
    return clearSingleDriverStatePatch();
  }

  return {
    drivers,
    hasDriver: true,
  };
}

export function buildSingleDriverStatePatch(
  option: DriverOption | null,
  dealerId: string,
  users: DealerUsersProps[],
): Pick<CoverageAreaProps, "drivers" | "hasDriver"> {
  if (!option) {
    return clearSingleDriverStatePatch();
  }
  return buildMapAreaDriversStatePatch([option], dealerId, users);
}
